/**
 * Feature Flag Configuration
 * Controls gradual rollout of UI v2 components
 * Set flags to true to enable new features for testing
 * Production defaults should be false until fully tested
 */

// Check for environment variables or localStorage overrides
const getFeatureFlag = (flagName, defaultValue = false) => {
  // Check localStorage first (for testing)
  const localOverride = localStorage.getItem(`feature_${flagName}`);
  if (localOverride !== null) {
    return localOverride === 'true';
  }
  
  // Check environment variable
  const envVar = process.env[`REACT_APP_FEATURE_${flagName}`];
  if (envVar !== undefined) {
    return envVar === 'true';
  }
  
  // Return default value
  return defaultValue;
};

// Feature flags for UI v2 rollout
const featureFlags = {
  // Dashboard feature - adds new dashboard without affecting existing chat
  NEW_DASHBOARD: getFeatureFlag('NEW_DASHBOARD', false),
  
  // Navigation v2 - enhanced navigation with dashboard link
  NEW_NAV: getFeatureFlag('NEW_NAV', false),
  
  // Chat interface v2 - enhanced layout with sidebars
  NEW_CHAT_LAYOUT: getFeatureFlag('NEW_CHAT_LAYOUT', false),
  
  // Voice mode v2 - improved voice interface
  VOICE_MODE_V2: getFeatureFlag('VOICE_MODE_V2', false),
  
  // Mobile optimizations
  MOBILE_BOTTOM_NAV: getFeatureFlag('MOBILE_BOTTOM_NAV', false),
  
  // A/B testing cohort assignment
  USER_COHORT: getFeatureFlag('USER_COHORT', 'control'), // 'control' | 'beta' | 'test'
  
  // Debug mode - shows feature flag status
  DEBUG_FLAGS: getFeatureFlag('DEBUG_FLAGS', false)
};

// Utility functions for feature flag management
export const enableFeature = (flagName) => {
  localStorage.setItem(`feature_${flagName}`, 'true');
  window.location.reload(); // Reload to apply changes
};

export const disableFeature = (flagName) => {
  localStorage.setItem(`feature_${flagName}`, 'false');
  window.location.reload(); // Reload to apply changes
};

export const clearFeatureOverrides = () => {
  Object.keys(featureFlags).forEach(flag => {
    localStorage.removeItem(`feature_${flag}`);
  });
  window.location.reload();
};

// Log feature flag status in development
if (process.env.NODE_ENV === 'development' && featureFlags.DEBUG_FLAGS) {
  console.log('Feature Flags Status:', featureFlags);
}

export default featureFlags;